import { Pipe, PipeTransform } from '@angular/core';
import { GamePeriod } from '../../domain/game-event';
import { periodEndGameTime } from '../../domain/game-periods';
import { Sport } from '../../domain/sport';

@Pipe({ name: 'countdown' })
export class CountdownTimePipe implements PipeTransform {
  constructor() {}

  transform(
    inputTime: number,
    period: GamePeriod | string,
    periodLength?: number,
    overtimeLength?: number,
    sport?: Sport
  ) {
    if (inputTime === null || !period) {
      return '';
    }

    const endSec = this.getEndSec(period, periodLength, overtimeLength, sport);
    const diffSec = endSec - inputTime;
    const s = (Math.ceil(diffSec) % 3600) % 60;
    const m = Math.ceil((diffSec - s) / 60);
    return ('0' + m).slice(-2) + ':' + ('0' + s).slice(-2);
  }

  // Without an overtime length, an overtime counts like another regular
  // period, as it always did.
  private getEndSec(
    period: GamePeriod | string,
    periodLen: number = 20,
    overtimeLen?: number,
    sport?: Sport
  ): number {
    if (overtimeLen) {
      return periodEndGameTime(
        period.toString(),
        periodLen,
        sport,
        overtimeLen
      );
    }
    return parseInt(period.toString(), 10) * periodLen * 60;
  }
}
